
import { fromJS } from 'immutable';

import * as utils from '@src/utils/duckHelpers';

const types = {
    ...utils.requestTypes('MONTHLY_JOB_AIDS'),
    MONTHLY_JOB_AIDS_SET: 'MONTHLY_JOB_AIDS_SET',
    MONTHLY_JOB_AIDS_GET: 'MONTHLY_JOB_AIDS_GET',
    MONTHLY_JOB_AIDS_SUCCESS: 'MONTHLY_JOB_AIDS_SUCCESS',
};

const initialState = fromJS({
    loaded: 'loading',
    jobAids: [],
    total: 0,
    page: 0,
});

const monthlyJobAidsReducer = (state = initialState, action) => {
    switch (action.type) {
    case types.MONTHLY_JOB_AIDS_GET:
        return state.merge({
            loaded: 'loading',
        });
    case types.MONTHLY_JOB_AIDS_SET:
        return state.merge({
            loaded: 'complete',
            jobAids: action.payload.job_aids,
            total: action.payload.total,
            page: action.payload.page,
        });
    case types.MONTHLY_JOB_AIDS_RESET:
        return initialState;
    default:
        return state;
    }
};

export {
    types,
    monthlyJobAidsReducer as default,
};
